import { render, staticRenderFns } from "./CreateFriendLink.vue?vue&type=template&id=03e9aa24&scoped=true"
import script from "./CreateFriendLink.vue?vue&type=script&lang=js"
export * from "./CreateFriendLink.vue?vue&type=script&lang=js"
import style0 from "./CreateFriendLink.vue?vue&type=style&index=0&id=03e9aa24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e9aa24",
  null
  
)

export default component.exports